import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getPropertiesClosedBySellerId } from '../../Redux/Actions/actions';
import CardSellerPropertiesClosed from '../CardSellerPropertiesClosed/CardSellerPropertiesClosed';
import style from './CardSellerPropertiesClosedContainer.module.css';

const CardSellerPropertiesClosedContainer = ({ userId, properties, getPropertiesClosedBySellerId }) => {
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    if (userId) {
      getPropertiesClosedBySellerId(userId);
    }
  }, [userId, getPropertiesClosedBySellerId]);

  if (!userId) {
    return <div>No se encontró el ID del usuario. Por favor, inicia sesión nuevamente.</div>;
  }

  const filteredProperties = properties.filter(p => {
    if (filter === 'all') return true;
    // Una operación externa real no tiene propertyType (campo exclusivo de Property)
    const isExterna = p.cerrado?.buyingTip === true && !p.propertyType;
    return filter === 'externas' ? isExterna : !isExterna;
  });

  const totalExternas = properties.filter(p => p.cerrado?.buyingTip === true && !p.propertyType).length;
  const totalPropias = properties.length - totalExternas;

  return (
    <div>
      <div className={style.filterBar}>
        <button
          className={`${style.filterButton} ${filter === 'all' ? style.filterActive : ''}`}
          onClick={() => setFilter('all')}
        >
          Todas ({properties.length})
        </button>
        <button
          className={`${style.filterButton} ${filter === 'propias' ? style.filterActive : ''}`}
          onClick={() => setFilter('propias')}
        >
          Propiedades ({totalPropias})
        </button>
        <button
          className={`${style.filterButton} ${filter === 'externas' ? style.filterActive : ''}`}
          onClick={() => setFilter('externas')}
        >
          Punta Compradora ({totalExternas})
        </button>
      </div>
      <div className="card-deck">
        {filteredProperties.length > 0 ? (
          filteredProperties.map((property) => (
            <CardSellerPropertiesClosed key={property.id} property={property} />
          ))
        ) : (
          <h3 className={style.emptyMessage}>
            {filter === 'externas'
              ? 'No hay operaciones de punta compradora.'
              : filter === 'propias'
              ? 'No hay propiedades cerradas propias.'
              : 'No hay propiedades cerradas disponibles para este vendedor.'}
          </h3>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  userId: state.userId, // Aquí asegúrate de que userId esté bien conectado al componente
  properties: state.propertiesClosedBySellerId || [], // Maneja un valor por defecto si no hay propiedades
});

export default connect(mapStateToProps, { getPropertiesClosedBySellerId })(CardSellerPropertiesClosedContainer);
